export enum HealthUnitLoginTypeEnum
{
    user = 1,
    google = 2,
    office365 = 3,
}